export default {
  ad: true,
  ae: true,
  af: true,
  ag: true,
  ai: true,
  al: true,
  am: true,
  ao: true,
  aq: true,
  ar: true,
  as: true,
  at: true,
  au: true,
  aw: true,
  ax: true,
  az: true,
  ba: true,
  bb: true,
  bd: true,
  be: true,
  bf: true,
  bg: true,
  bh: true,
  bi: true,
  bj: true,
  bl: true,
  bm: true,
  bn: true,
  bo: true,
  'bq-bo': true,
  'bq-sa': true,
  'bq-se': true,
  br: true,
  bs: true,
  bt: true,
  xx: true,
  bv: true,
  bw: true,
  by: true,
  bz: true,
  'ca-bc': true,
  ca: true,
  cc: true,
  cd: true,
  cf: true,
  cg: true,
  ch: true,
  ci: true,
  ck: true,
  cl: true,
  cm: true,
  cn: true,
  'cn-xj': true,
  co: true,
  cr: true,
  cu: true,
  cv: true,
  cw: true,
  cx: true,
  cy: true,
  cz: true,
  de: true,
  dj: true,
  dk: true,
  dm: true,
  do: true,
  dz: true,
  earth: true,
  east_african_federation: true,
  easter_island: true,
  'ec-w': true,
  ec: true,
  ee: true,
  eg: true,
  eh: true,
  er: true,
  'es-ce': true,
  'es-cn': true,
  'es-ct': true,
  'es-ga': true,
  'es-ib': true,
  'es-ml': true,
  'es-pv': true,
  es: true,
  esperanto: true,
  et: true,
  european_union: true,
  fi: true,
  fj: true,
  fk: true,
  fm: true,
  fo: true,
  'fr-h': true,
  fr: true,
  ga: true,
  'gb-eng': true,
  'gb-ork': true,
  'gb-sct': true,
  'gb-wls': true,
  gb: true,
  gd: true,
  'ge-ab': true,
  ge: true,
  gg: true,
  gh: true,
  gi: true,
  gl: true,
  gm: true,
  gn: true,
  gp: true,
  gq: true,
  gr: true,
  gs: true,
  gt: true,
  gu: true,
  gw: true,
  gy: true,
  hausa: true,
  hk: true,
  hmong: true,
  hm: true,
  hn: true,
  hr: true,
  ht: true,
  hu: true,
  id: true,
  'id-jb': true,
  'id-jt': true,
  ie: true,
  il: true,
  im: true,
  in: true,
  'in-gj': true,
  'in-or': true,
  'in-tn': true,
  io: true,
  iq: true,
  ir: true,
  is: true,
  'it-82': true,
  'it-88': true,
  it: true,
  je: true,
  jm: true,
  jo: true,
  jp: true,
  kannada: true,
  ke: true,
  kg: true,
  kh: true,
  ki: true,
  km: true,
  kn: true,
  kp: true,
  kr: true,
  kurdistan: true,
  kw: true,
  ky: true,
  kz: true,
  la: true,
  lb: true,
  lc: true,
  li: true,
  lk: true,
  lr: true,
  ls: true,
  lt: true,
  lu: true,
  lv: true,
  ly: true,
  ma: true,
  malayali: true,
  maori: true,
  mc: true,
  md: true,
  me: true,
  mf: true,
  mg: true,
  mh: true,
  mk: true,
  ml: true,
  mm: true,
  mn: true,
  mo: true,
  mp: true,
  mq: true,
  mr: true,
  ms: true,
  mt: true,
  mu: true,
  mv: true,
  mw: true,
  mx: true,
  my: true,
  mz: true,
  na: true,
  nc: true,
  nato: true,
  ne: true,
  nf: true,
  ng: true,
  ni: true,
  nl: true,
  'nl-fr': true,
  no: true,
  northern_cyprus: true,
  np: true,
  nr: true,
  nu: true,
  nz: true,
  olympics: true,
  om: true,
  pa: true,
  pe: true,
  pf: true,
  pg: true,
  ph: true,
  pk: true,
  pl: true,
  pm: true,
  pn: true,
  pr: true,
  ps: true,
  'pt-20': true,
  'pt-30': true,
  pt: true,
  pw: true,
  py: true,
  qa: true,
  re: true,
  ro: true,
  rs: true,
  ru: true,
  'ru-ta': true,
  rw: true,
  sa: true,
  sb: true,
  sc: true,
  sd: true,
  se: true,
  sg: true,
  'sh-hl': true,
  'sh-ac': true,
  'sh-ta': true,
  si: true,
  sindh: true,
  sj: true,
  sk: true,
  sl: true,
  sm: true,
  sn: true,
  so: true,
  somaliland: true,
  south_ossetia: true,
  sr: true,
  ss: true,
  st: true,
  su: true,
  sv: true,
  sx: true,
  sy: true,
  sz: true,
  tc: true,
  td: true,
  tf: true,
  tg: true,
  th: true,
  tibet: true,
  tj: true,
  tk: true,
  tl: true,
  tm: true,
  tn: true,
  to: true,
  torres_strait_islands: true,
  tr: true,
  transnistria: true,
  tt: true,
  tv: true,
  tw: true,
  tz: true,
  ua: true,
  ug: true,
  united_nations: true,
  um: true,
  'us-hi': true,
  us: true,
  uy: true,
  uz: true,
  va: true,
  vc: true,
  ve: true,
  vg: true,
  vi: true,
  vn: true,
  vu: true,
  wf: true,
  ws: true,
  xk: true,
  placeholder: false,
  ye: true,
  yt: true,
  yiddish: true,
  za: true,
  zm: true,
  zw: true
}
